module.exports = __webpack_public_path__ + "img/bottom.b69e50c5.png";